import React from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1, // Default retry count on failure
      staleTime: 60 * 1000, // 1 minute by default
      refetchOnWindowFocus: false, // Disable refetch on window focus by default
      refetchOnMount: true, // Refetch on component mount by default
    },
  },
})

interface QueryProviderProps {
  children: React.ReactNode
}

/**
 * Provider component for React Query
 * Wrap your application with this provider to use React Query
 */
export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools />}
    </QueryClientProvider>
  )
}

export default QueryProvider
